/* EM-PARTNERS · "Completa l'outfit" nel carrello · Live Store Milano (30/10/2026)
   Suggerisce i capi che i clienti comprano davvero insieme (assets/em-outfit.json, dagli ordini dal 22/9):
   - categoria del capo dall'inizio dell'handle (felpa-, jeans-, t-shirt-, bomber-…);
   - categorie da proporre: quelle comprate più spesso con quelle nel carrello, mai lo stesso "posto"
     (sopra / sotto / giacca): felpa → pantalone o jeans, jeans → t-shirt o felpa, sopra + sotto → giubbotto;
   - prodotti: prima quelli comprati insieme ai capi nel carrello, poi i più venduti della categoria;
   - taglia preselezionata se c'è la stessa del carrello, altrimenti si sceglie; aggiunta con un tocco.
   Lavora solo quando il cassetto del carrello è aperto o nella pagina carrello. Non dipende dalla promo. */
(function () {
  'use strict';
  if (window.__emOutfit) return;
  window.__emOutfit = true;

  var cfgPromise = null;
  var products = {};

  function cfg() {
    if (!cfgPromise) {
      cfgPromise = fetch(window.EM_OUTFIT_URL, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .catch(function () { cfgPromise = null; return null; });
    }
    return cfgPromise;
  }
  function product(h) {
    if (!products[h]) {
      products[h] = fetch('/products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return products[h];
  }
  function catOf(c, h) {
    var w = String(h || '').toLowerCase().split('-');
    if (w[0] === 'copia' && /^(del|di|della)$/.test(w[1])) w = w.slice(2);
    return c.pfx[w[0]] || 'altro';
  }
  function sizeOf(item) {
    var o = (item.options_with_values || []).filter(function (x) { return /taglia|size|misura/i.test(x.name); })[0];
    return o ? String(o.value) : null;
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; });
  }
  function money(cents) {
    var fmt = (window.theme && window.theme.settings && window.theme.settings.money_format) || '€{{amount}}';
    var v = (cents / 100).toFixed(2);
    return String(fmt).replace(/<[^>]*>/g, '')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, v);
  }

  /* Quali prodotti proporre, in ordine. */
  function choose(c, cart) {
    var items = cart.items.filter(function (i) { return !i.gift_card; });
    var inCart = {}, slots = {}, cats = {};
    items.forEach(function (i) {
      inCart[i.handle] = 1;
      var k = catOf(c, i.handle), s = c.slot[k];
      cats[k] = 1;
      if (s === 'set') { slots.top = 1; slots.bot = 1; } else if (s) { slots[s] = 1; }
    });
    var score = {};
    items.forEach(function (i) {
      (c.next[catOf(c, i.handle)] || []).forEach(function (d, n) {
        var s = c.slot[d];
        if (slots[s] || (s === 'set' && (slots.top || slots.bot))) return;
        score[d] = (score[d] || 0) + 1 / (n + 1);
      });
    });
    var targets = Object.keys(score).sort(function (a, b) { return score[b] - score[a]; }).slice(0, 2);
    if (!targets.length) targets = !slots.out ? ['giubbotto'] : (!cats.calze ? ['calze'] : ['tshirt']);

    var list = [];
    items.slice().sort(function (a, b) { return b.final_line_price - a.final_line_price; }).forEach(function (i) {
      (c.pairs[i.handle] || []).forEach(function (h) { if (targets.indexOf(catOf(c, h)) > -1) list.push(h); });
    });
    targets.forEach(function (t) { (c.top[t] || []).forEach(function (h) { list.push(h); }); });
    var seen = {};
    return list.filter(function (h) {
      if (inCart[h] || seen[h]) return false;
      seen[h] = 1;
      return true;
    }).slice(0, 8);
  }

  function card(p, sizes) {
    var idx = -1;
    (p.options || []).forEach(function (o, n) { if (idx < 0 && /taglia|size|misura/i.test(o.name || o)) idx = n; });
    var avail = p.variants.filter(function (v) { return v.available; });
    var pre = null;
    if (avail.length === 1) pre = avail[0];
    else if (idx > -1) pre = avail.filter(function (v) { return sizes.indexOf(String(v.options[idx])) > -1; })[0] || null;
    var pick;
    if (idx > -1 || avail.length > 1) {
      pick = '<select class="em-of__size" aria-label="Taglia">' + (pre ? '' : '<option value="">Taglia</option>') +
        avail.map(function (v) {
          var label = idx > -1 ? v.options[idx] : v.title;
          return '<option value="' + v.id + '"' + (pre && pre.id === v.id ? ' selected' : '') + '>' + esc(label) + '</option>';
        }).join('') + '</select>';
    } else {
      pick = '<input type="hidden" class="em-of__size" value="' + avail[0].id + '">';
    }
    var img = p.featured_image ? String(p.featured_image).replace(/^\/\//, 'https://') : '';
    if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
    return '<div class="em-of__card">' +
      '<a class="em-of__img" href="/products/' + p.handle + '">' + (img ? '<img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy" width="64" height="85">' : '') + '</a>' +
      '<a class="em-of__t" href="/products/' + p.handle + '">' + esc(p.title) + '</a>' +
      '<span class="em-of__p">' + money(p.price) + '</span>' +
      '<div class="em-of__buy">' + pick + '<button type="button" class="em-of__add" aria-label="Aggiungi ' + esc(p.title) + '">+</button></div>' +
      '</div>';
  }

  function build(el) {
    if (el._busy) return;
    el._busy = true;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var sig = cart.items.map(function (i) { return i.key + ':' + i.quantity; }).join(',');
      if (!cart.items.length) { el.hidden = true; return null; }
      if (sig === el._sig) return null;
      el._sig = sig;
      return cfg().then(function (c) {
        if (!c) { el.hidden = true; return; }
        var sizes = cart.items.map(sizeOf).filter(Boolean);
        var hs = choose(c, cart);
        return Promise.all(hs.map(product)).then(function (ps) {
          var per = {}, out = [];
          ps.forEach(function (p) {
            if (!p || !p.available || out.length >= 4) return;
            var k = catOf(c, p.handle);
            per[k] = (per[k] || 0) + 1;
            if (per[k] <= 2) out.push(p);
          });
          if (!out.length) { el.hidden = true; return; }
          el.querySelector('.em-of__row').innerHTML = out.map(function (p) { return card(p, sizes); }).join('');
          el.hidden = false;
        });
      });
    }).catch(function () {}).then(function () { el._busy = false; });
  }

  function add(el, btn) {
    var box = btn.closest('.em-of__card');
    var sel = box.querySelector('.em-of__size');
    var id = sel && sel.value;
    if (!id) { sel.classList.add('is-err'); sel.focus(); return; }
    btn.disabled = true;
    btn.textContent = '…';
    var drawer = document.querySelector('cart-drawer');
    var onCartPage = /^\/cart\/?$/.test(location.pathname);
    var secs = (!onCartPage && drawer && drawer.getSectionsToRender) ? drawer.getSectionsToRender().map(function (s) { return s.section; }) : [];
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: secs, sections_url: location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (!res || res.status) { btn.textContent = '×'; return; }
      if (onCartPage || !drawer || !drawer.renderContents) { location.reload(); return; }
      el._sig = null;
      drawer.renderContents(res, true);
    }).catch(function () { btn.disabled = false; btn.textContent = '+'; });
  }

  if (!customElements.get('em-outfit')) {
    customElements.define('em-outfit', class extends HTMLElement {
      connectedCallback() {
        var el = this;
        el.addEventListener('click', function (e) {
          var b = e.target.closest('.em-of__add');
          if (b) add(el, b);
        });
        el.addEventListener('change', function (e) {
          if (e.target.classList.contains('em-of__size')) e.target.classList.remove('is-err');
        });
        var drawer = el.closest('cart-drawer');
        if (!drawer) { build(el); return; }
        if (drawer.classList.contains('is-visible')) build(el);
        el._mo = new MutationObserver(function () { if (drawer.classList.contains('is-visible')) build(el); });
        el._mo.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      }
      disconnectedCallback() { if (this._mo) this._mo.disconnect(); }
    });
  }
})();
